import qs from '@halobear/utils/qs'

function appType() {
  const typeMap = {
    // miniapp: "app-travel-mini",
    // aliapp: "app-travel-alipay-mini",
    // ttapp: "app-travel-byte-mini",
    // swanapp: "app-travel-baidu-mini"
    miniapp: "wx",
    aliapp: "my",
    ttapp: "tt",
    swanapp: "swan"
  }
  const from = qs.get('from')
  return typeMap[from]
}
let sdkPromise

function loadSDk() {
  if (!type) return
  const sdkMap = {
    wx: '',
    swan: 'https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.22.js',
    my: 'https://appx/web-view.min.js',
    tt: 'https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js'
  }
  const sdk = sdkMap[type]
  if (!sdk) return true
  sdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = sdk
    script.onload = resolve()
    script.onerror = (e) => {
      sdkPromise = null
      reject(e)
    }
    document.head.appendChild(script)
  })
  return sdkPromise
}

export const type = appType()
loadSDk()

export async function navigateTo(url) {
  if (!url) return
  if (!type) return console.warn('不是小程序环境')
  await loadSDk()
  if (type === 'my') {
    return window.my.navigateTo({ url })
  }
  const action = window[type].miniProgram || window[type].webView
  // console.log(window[type], url)
  return action.navigateTo({
    url
  })
}

